import React from 'react';
import { Bubble, BubbleProps } from 'tea-component';
import BubbleClose from '@/pages/intelligence/components/BubbleClose';

interface DownLoadType extends BubbleProps {
  hasCloseIcon?: boolean;
  onClose?: () => void;
  children: any;
  content?: React.ReactNode;
}
const DownLoadBubble = (props: DownLoadType) => {
  const { onClose, hasCloseIcon = false, children, content, ...rest } = props;

  if (!content) {
    return children;
  }

  if (hasCloseIcon) {
    return (
      <BubbleClose
        placement="top-end"
        dark
        content={content}
        onClose={onClose}
        {...rest}
      >
        {children}
      </BubbleClose>
    );
  }
  return (
    <Bubble placement="top-end" dark content={content} {...rest}>
      {children}
    </Bubble>
  );
};

export default DownLoadBubble;
